import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../environment/Apiurl";
import { getEffectiveRolePages } from "../../utils/rolePagesMigration";

import {
  FaUser,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
} from "react-icons/fa";

import logo_full from "../../assets/images/Logo.png";
import logo_icon from "../../assets/images/logo avatar.png";

import "./Login.css";

const Login = () => {
  const navigate = useNavigate();

  const [user_id, setUser_id] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");

    if (!user_id.trim()) {
      setError("Please enter User ID");
      return;
    }

    if (!password.trim()) {
      setError("Please enter Password");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${ApiUrl}/login`, {
        user_id: user_id.trim(),
        password,
      });

      const data = response.data;

      if (data.status === "success") {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_id", data.user.user_id);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("role_id", data.user.role_id || "");
        localStorage.setItem("role_name", data.user.role_name || "");
        localStorage.setItem("user_type", data.user.user_type || "");
        localStorage.setItem("department", data.user.department || "");
        localStorage.setItem("name", data.user.name || "");
        const effectivePages = getEffectiveRolePages(
          data.user.role_name,
          data.user.pages || []
        );
        localStorage.setItem("role_pages", JSON.stringify(effectivePages));
        axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;

        navigate("/dashboard");
      } else {
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);

      if (err.response) {
        setError(
          err.response.data?.message ||
            "Login failed. Please check your credentials."
        );
      } else if (err.request) {
        setError("No response from server. Please check your connection.");
      } else {
        setError("An error occurred. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <div className="health-login-page">

      <div className="health-login-container">

        {/* ================= LEFT ================= */}

        <div className="health-login-left">

          <div className="health-left-content">

            {/* Logo */}

            <div className="health-brand">

              <div className="health-brand-logo">
                <img
                  src={logo_icon}
                  alt="4Health"
                />
              </div>

              <span>
                4Health Homeopathy
              </span>

            </div>

            {/* Medical Visual */}

            <div className="health-medical-design" />

            {/* Text */}

            <div className="health-left-bottom">

              <h1 className="health-left-title">
                Better Care.
                <br />
                Smarter Management.
              </h1>

              <p className="health-left-desc">
                Manage patients,
                appointments,
                prescriptions,
                pharmacy and clinic
                operations from one
                simple platform.
              </p>

              <div className="health-slider-dots">

                <span className="health-slider-dot active" />

                <span className="health-slider-dot" />

                <span className="health-slider-dot" />

              </div>

            </div>

          </div>

        </div>

        {/* ================= RIGHT ================= */}

        <div className="health-login-right">

          <img
            src={logo_full}
            alt="4Health Homeopathy"
            className="health-right-logo"
          />

          <div className="health-form-container">

            <h2 className="health-login-title">
              Welcome Back!
            </h2>

            <p className="health-login-subtitle">
              Sign in to your account
            </p>

            {error && (
              <div className="health-login-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>

              {/* User ID */}

              <div className="health-field">

                <label className="health-label">
                  User ID
                </label>

                <div className="health-input-wrap">

                  <FaUser className="health-field-icon" />

                  <input
                    type="text"
                    value={user_id}
                    onChange={(e) =>
                      setUser_id(e.target.value)
                    }
                    placeholder="Enter your User ID"
                    className="health-input"
                    autoComplete="username"
                  />

                </div>

              </div>

              {/* Password */}

              <div className="health-field">

                <label className="health-label">
                  Password
                </label>

                <div className="health-input-wrap">

                  <FaLock className="health-field-icon" />

                  <input
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                    placeholder="Enter your Password"
                    className="health-input"
                    autoComplete="current-password"
                  />

                  <button
                    type="button"
                    className="health-eye-btn"
                    onClick={() =>
                      setShowPassword(
                        !showPassword
                      )
                    }
                  >
                    {showPassword
                      ? <FaEyeSlash />
                      : <FaEye />}
                  </button>

                </div>

              </div>

              {/* Login */}

              <button
                type="submit"
                className="health-login-btn"
                disabled={isLoading}
              >

                {isLoading ? (
                  <>
                    <span className="health-spinner" />
                    Signing in...
                  </>
                ) : (
                  <>
                    Login
                    <FaArrowRight size={12} />
                  </>
                )}

              </button>

            </form>

            <div className="health-divider">
              4Health Clinic CRM
            </div>

            <div className="health-system-info">

              <span className="health-system-dot" />

              Secure clinic management system

            </div>

          </div>

        </div>

      </div>
      <div className="login-copyright">
  Copyrights © 2026 4Health Homeopathy Clinic - Developed by Aalan Techsoft, Salem
</div>
    </div>
  );
};

export default Login;